import { Badge } from "@/components/Badge";
import i18n from "@/i18n";
import { DownloadButton } from "@/components/DownloadButton";
import { ExportStatus } from "@/lib/utils/exportStatus";
import { statusToBadgeColor } from "@/lib/utils/statusTobadgeColor";
import { parseDateWithHours } from "@/lib/utils";
import { ColumnDef } from "@tanstack/react-table";
import { Link } from "@heroui/react";

export type E3DataUpload = {
  id: string;
  generated_at: string;
  client: string;
  report_date: string;
  user: string;
  file_name: string;
  status: string;
};

export const data_upload_columns: ColumnDef<E3DataUpload>[] = [
  { accessorKey: "id", header: "Id" },
  {
    accessorKey: "file_name",
    header: "Nom du fichier",
    cell: ({ getValue }) => {
      const value = getValue() as string;
      return (
        <span className="whitespace-nowrap overflow-hidden text-ellipsis block">
          {value}
        </span>
      );
    },
  },
  { accessorKey: "user_name", header: "Utilisateur" },
  {
    accessorKey: "status",
    header: "Statut",
    cell: ({ getValue }) => {
      const value = getValue() as ExportStatus;
      const badgeColor = statusToBadgeColor[value] || "error";
      return <Badge color={badgeColor} />;
    },
  },
  { accessorKey: "provider_config_name", header: "Configuration" },
  {
    accessorKey: "created_at",
    header: "Date de création",
    cell: ({ row }) => {
      const cell_data: string | undefined = row.getValue("created_at");
      if (cell_data) {
        return parseDateWithHours(cell_data);
      }
      return "";
    },
  },
  {
    accessorKey: "updated_at",
    header: "Dernière Modification",
    cell: ({ row }) => {
      const cell_data: string | undefined = row.getValue("updated_at");
      if (cell_data) {
        return parseDateWithHours(cell_data);
      }
      return "";
    },
  },
  {
    accessorKey: "download",
    header: "Télécharger",
    cell: ({ row }) => {
      const id = row.getValue("id") as string;
      const fileName = row.getValue("file_name") as string;
      const href = `${
        import.meta.env.VITE_BACKEND_URL
      }/e3/e3_data_upload/download/${id}`;

      return (
        <div className="flex flex-row items-center justify-between w-full">
          <DownloadButton
            href={href}
            filename={`${fileName}`}
            size="sm"
            variant="light"
            color="primary"
            isIconOnly
          />
          <div className="flex justify-end">
            <Link
              href={`${window.location.pathname}/${row.getValue("id")}`}
              className="text-xs"
              underline="hover"
            >
              {i18n.t("actions.details")}
            </Link>
          </div>
        </div>
      );
    },
  },
];
